module.exports = __webpack_public_path__ + "media/images/leaddyno-09dd4fa01289ca588ca1ba43ad39bca1.svg";